import { useEffect } from "react";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { $getRoot, $createParagraphNode } from "lexical";
import { $generateNodesFromDOM } from "@lexical/html";

type Props = { initialContent?: string }   
 
export const LoadInitialContent = ({ initialContent }: Props) => {
    const [editor] = useLexicalComposerContext();
    
    useEffect(() => {
        if (!initialContent) { return; }
        editor.update(() => {
            $getRoot().clear();
            const parser = new DOMParser();
            const dom = parser.parseFromString(initialContent, "text/html");
            const nodes = $generateNodesFromDOM(editor, dom);
            const paragraphNode = $createParagraphNode();
            nodes.forEach(n => paragraphNode.append(n));
            $getRoot().append(paragraphNode);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialContent]);
    return null;
  };